module.exports = __webpack_public_path__ + "img/zhengzhou_daxue_fuzhu.c50aead1.png";